import { render, staticRenderFns } from "./NavMenuLogo.vue?vue&type=template&id=6b85ff31&scoped=true&"
import script from "./NavMenuLogo.vue?vue&type=script&lang=js&"
export * from "./NavMenuLogo.vue?vue&type=script&lang=js&"
import style0 from "./NavMenuLogo.vue?vue&type=style&index=0&id=6b85ff31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b85ff31",
  null
  
)

export default component.exports